export const FETCH_CUISINE_TYPES = {
  START: 'START_FETCH_CUISINE_TYPES',
  COMPLETE: 'COMPLETE_FETCH_CUISINE_TYPES',
  FAIL: 'FAIL_FETCH_CUISINE_TYPES',
  CLEANUP: 'CLEANUP_FETCH_CUISINE_TYPES',
}

export const ADD_CUISINE_TYPE = 'ADD_CUISINE_TYPE'
export const RENAME_CUISINE_TYPE = 'RENAME_CUISINE_TYPE'
export const RESET_CUISINE_TYPE_TREE = 'RESET_CUISINE_TYPE_TREE'

export const SET_DATA_FOR_RENAMING_CUISINE_TYPE =
  'SET_DATA_FOR_RENAMING_CUISINE_TYPE'

export const SET_IS_CURATION_ENABLED_CUISINE_TYPE = {
  START: 'START_SET_IS_CURATION_ENABLED_CUISINE_TYPE',
  COMPLETE: 'COMPLETE_SET_IS_CURATION_ENABLED_CUISINE_TYPE',
  FAIL: 'FAIL_SET_IS_CURATION_ENABLED_CUISINE_TYPE',
}

export const DELETE_CUISINE_TYPE = {
  START: 'START_DELETE_CUISINE_TYPE',
  COMPLETE: 'COMPLETE_DELETE_CUISINE_TYPE',
  FAIL: 'FAIL_DELETE_CUISINE_TYPE',
}

export const REPLACE_CUISINE_TYPE = {
  START: 'START_REPLACE_CUISINE_TYPE',
  COMPLETE: 'COMPLETE_REPLACE_CUISINE_TYPE',
  FAIL: 'FAIL_REPLACE_CUISINE_TYPE',
}

export const REVERT_REPLACE_CUISINE_TYPE = {
  START: 'START_REVERT_REPLACE_CUISINE_TYPE',
  COMPLETE: 'COMPLETE_REVERT_REPLACE_CUISINE_TYPE',
  FAIL: 'FAIL_REVERT_REPLACE_CUISINE_TYPE',
}

export const MOVE_CUISINE_TYPES = 'MOVE_CUISINE_TYPES'

export const SAVE_CUISINE_TYPES = {
  START: 'START_SAVE_CUISINE_TYPES',
  COMPLETE: 'COMPLETE_SAVE_CUISINE_TYPES',
  FAIL: 'FAIL_SAVE_CUISINE_TYPES',
}

export const EXPAND_CUISINE_TYPE_MAIN_TREE_KEYS =
  'EXPAND_CUISINE_TYPE_MAIN_TREE_KEYS'

export const EXPAND_CUISINE_TYPE_SUPPORTING_TREE_KEYS =
  'EXPAND_CUISINE_TYPE_SUPPORTING_TREE_KEYS'
